import { Component, ViewChild } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';

import * as moment from 'moment-mini';
import { of } from 'rxjs';
import { PscFunctions } from '../functions/pscFunctions';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTablePermissions, } from '@aims/common-components';

@Component({
  selector: 'pscGenerateFiscalPay',
  templateUrl: './pscGenerateFiscalPay.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [PscFunctions]
})

export class PscGenerateFiscalPayComponent {
  now: DateConstructor;

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService,
    public pscFunc: PscFunctions) {
  }

  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  }
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'jobTitleAndWs', label: 'Job Title - Work Section', type: 'string', width: 160 },
    { key: 'payRateFrom', label: 'Pay Rate From', type: 'dynamic', },
    { key: 'payRateTo', label: 'Pay Rate To', type: 'dynamic', },
    { key: 'percentage', label: 'Percentage', type: 'dynamic', },
    { key: 'pmmApprovedById', label: 'PMM Approve By', type: 'dynamic', filterType: AimsCommonTableFilterType.DYNAMIC,
      events: { filterAndSortCompare: (term, el) => term === el.pmmApprovedById} },
    { key: 'pmmApprovedOn', label: 'PMM Approved On', type: 'date', },
    { key: 'hrmApprovedById', label: 'HRM Approve By', type: 'dynamic', filterType: AimsCommonTableFilterType.DYNAMIC,
      events: { filterAndSortCompare: (term, el) => term === el.hrmApprovedById } },
    { key: 'hrmApprovedOn', label: 'HRM Approved On', type: 'date', },
    { key: 'pscsGenerated', label: 'PSC Generated', type: 'boolean', filterType: AimsCommonTableFilterType.BOOLEAN },
  ];

  @ViewChild('fiscalPayForm', { static: true }) fiscalPayForm; FormGroup

  canPmmApprove: boolean = false;
  canHrmApprove: boolean = false;
  canPrint: boolean = false;
  canCreate: boolean = false;

  fyYear: number = null;
  strEffectiveOn: string = null;

  //Hardcoded to 10/1/fyYear -- Acct said it is always 10/1
  //showEffectiveOnPopUp: boolean = false;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Header
  headerText = "Review / Approve Fiscal Pay Increases for: ";

  //DropDown Values
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  fyYearValues = this.transferHttp.getHot('hr/GetDistinctFyYearsForDropDown');
  activeJobtitlesUnionValues = this.transferHttp.getHot('hr/GetActiveJobTitlesUnionOnlyForDropDown');

  public fiscalPay = of([]);

  //***************************
  // Functions
  //***************************

  public getFromToPayRates() {
    this.fiscalPay = this.transferHttp.getHot(`hr/GetFiscalPayIncreaseFor?fyYear=${this.fyYear}`);
    this.strEffectiveOn = '10/01/' + (this.fyYear - 1).toString();

    this.fiscalPay.subscribe(data => {
      this.canPmmApprove = data.filter(p => p.pmmApprovedById == null).length > 0 && this.permissions.canUpdate(this.permissions.ComponentID.PscPmmApprovalQueue);
      this.canHrmApprove = data.filter(p => p.hrmApprovedById == null && p.pmmApprovedById != null).length > 0 && this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue);
      this.canCreate = data.filter(p => p.pmmApprovedById != null && p.hrmApprovedById != null && !p.pscsGenerated).length > 0 && this.permissions.canCreate(this.permissions.ComponentID.PscGenerateFiscalPay);
      this.canPrint = data.filter(p => p.pscsGenerated).length > 0 && this.permissions.canRead(this.permissions.ComponentID.PscHrmApprovalQueue);
    });
  }

  public updatePmmApproval() {
    this.showSpinner = true;
    this.spinnerText = 'Updating PMM Approval for ' + this.fyYear;

    this.transferHttp.put(`hr/PmmApproveFyPayRates?fyYear=${this.fyYear}`, null).subscribe(retVal => {
      this.getFromToPayRates();
      this.showSpinner = false;
    });
  }

  public updateHrmApproval() {
    this.showSpinner = true;
    this.spinnerText = 'Updating HRM Approval for ' + this.fyYear;

    this.transferHttp.put(`hr/HrmApproveFyPayRates?fyYear=${this.fyYear}`, null).subscribe(retVal => {
      this.getFromToPayRates();
      this.showSpinner = false;
    });
  }

  //public createPscs() {

  //  this.showEffectiveOnPopUp = true;
  //}

  //public cancelEffectiveOn(): void {
  //  this.showEffectiveOnPopUp = false;
  //  this.strEffectiveOn = null;
  //}


  public autoGeneratePscs() {
    //this.showEffectiveOnPopUp = false;
    this.showSpinner = true;
    this.spinnerText = 'Creating Fiscal Pay Change PSCs for ' + this.fyYear + ' effective on: ' + this.strEffectiveOn;

    this.transferHttp.post(`hr/CreateFiscalPayPscs?fyYear=${this.fyYear}&effectiveOn=${moment(this.strEffectiveOn, 'MM/DD/YYYY', false).format()}`, null).subscribe(retVal => {

      this.getFromToPayRates();
      this.showSpinner = false;

    });
  }

  public printAll() {
   const url = `reporting/HR_PrintFiscalPayChanges/trdp/{"effectiveOn":"${moment(this.strEffectiveOn, 'MM/DD/YYYY', false).format('YYYY-MM-DD')}"}`;
    this.router.navigate([url]);
  }

  public cancel() {
    this.router.navigate([`/hr`]);
  }

  ngOnInit(): void {
  }

}
